import './App.css';
import Header from './Components/Header/Header';
import RestrictedRoutes from './Components/Header/RestrictedRoutes';
import {
  Route,
  Routes,
  BrowserRouter as Router,
  useNavigate,
} from 'react-router-dom';
import Login from './Components/Login/Login';
import Footer from './Components/Footer/Footer';
import Home from './Pages/Home';
import Bonus from './Components/Bonus/Bonus';
import Hotel from './Components/Hotel/Hotel';
import Mileage from './Components/Mileage/Mileage';
import NewHire from './Components/NewHire/NewHire';
import PerDiem from './Components/PerDiem/PerDiem';
import Pto from './Components/Pto/Pto';
import TargetOrder from './Components/TargetOrder/TargetOrder';
import Termination from './Components/Termination/Termination';
import TimeAdjustment from './Components/TimeAdjustment/TimeAdjustment';
import Uniform from './Components/Uniform/Uniform';
import WorkTicket from './Components/WorkTicket/WorkTicket';
import CbmState from './Context/Cbm/cbmState';
import AdminState from './Context/Admin/adminState';
import Logout from './Components/Logout/Logout';
import SubmissionSuccess from './Pages/SubmissionSuccess';
import SecureDownload from './Pages/SecureDownload';
import SecurePackage from './Pages/SecurePackage';
import NonMnMileage from './Components/NonMnMileage/NonMnMileage';
import ErrorBanner from './Components/ErrorBanner/ErrorBanner';
import { useEffect } from 'react';

import Admin from './Pages/Admin';

// Component inside Router that can use useNavigate
function AppContent() {
  const navigate = useNavigate();

  useEffect(() => {
    // AppContent mounted (interceptors initialized in index.js)
  }, [navigate]);

  return (
    <>
      <Header />
      <ErrorBanner />
      <Routes>
        <Route
          path="/"
          element={
            <RestrictedRoutes>
              <Home />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/admin"
          element={
            <RestrictedRoutes>
              <Admin />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/bonus"
          element={
            <RestrictedRoutes>
              <Bonus />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/hotel"
          element={
            <RestrictedRoutes>
              <Hotel />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/mileage"
          element={
            <RestrictedRoutes>
              <Mileage />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/nonmnmileage"
          element={
            <RestrictedRoutes>
              <NonMnMileage />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/newhire"
          element={
            <RestrictedRoutes>
              <NewHire />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/perdiem"
          element={
            <RestrictedRoutes>
              <PerDiem />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/pto"
          element={
            <RestrictedRoutes>
              <Pto />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/success"
          element={
            <RestrictedRoutes>
              <SubmissionSuccess />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/secure/forms/:formType/:formToken"
          element={
            <RestrictedRoutes>
              <SecureDownload />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/secure/forms/:formType/:formToken/uploads-zip"
          element={
            <RestrictedRoutes>
              <SecureDownload />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/secure/forms/:formType/:formToken/uploads.zip"
          element={
            <RestrictedRoutes>
              <SecureDownload />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/secure/forms/:formType/:formToken/files/:fileCategory"
          element={
            <RestrictedRoutes>
              <SecureDownload />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/secure-package/:formType/:formToken"
          element={
            <RestrictedRoutes>
              <SecurePackage />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/targetorder"
          element={
            <RestrictedRoutes>
              <TargetOrder />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/termination"
          element={
            <RestrictedRoutes>
              <Termination />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/timeadjustment"
          element={
            <RestrictedRoutes>
              <TimeAdjustment />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/uniform"
          element={
            <RestrictedRoutes>
              <Uniform />
            </RestrictedRoutes>
          }
        />
        <Route
          path="/workticket"
          element={
            <RestrictedRoutes>
              <WorkTicket />
            </RestrictedRoutes>
          }
        />
        <Route path="/logout" element={<Logout />} />
        <Route path="/login" element={<Login />} />
      </Routes>

      {/* <RouterProvider router={router} /> */}
      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
}

function App() {
  return (
    <Router>
      <CbmState>
        <AdminState>
          <AppContent />
        </AdminState>
      </CbmState>
    </Router>
  );
}

export default App;
